import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { detectLanguage, getTranslation } from '../helper/i18n';

// Simple fade-in/fade-out and sticky visual styling
const sectionStyle = {
  margin: '60px 0',
  padding: '32px',
  background: 'rgba(255,255,255,0.95)',
  borderRadius: '16px',
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
};
const visualStyle = {
  width: '100%',
  maxWidth: 900,
  height: 500,
  border: '1px solid #ccc',
  borderRadius: 8,
  boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  marginBottom: 24
};

const QuizPreview = ({ section }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCorrect, setIsCorrect] = useState(null);
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    if (section.question) {
      const detectedLang = detectLanguage(section.question);
      setLanguage(detectedLang);
    }
  }, [section.question]);

  const handleAnswerClick = (index) => {
    if (!isSubmitted) {
      setSelectedAnswer(index);
    }
  };

  const handleSubmit = () => {
    if (selectedAnswer === null) return;
    setIsSubmitted(true);
    setIsCorrect(selectedAnswer === section.correctAnswerIndex);
  };

  const handleReset = () => {
    setSelectedAnswer(null);
    setIsSubmitted(false);
    setIsCorrect(null);
  };

  return (
    <div>
      <h4 style={{ marginBottom: '20px', fontWeight: '600' }}>{section.question}</h4>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {(section.answers || []).map((answer, index) => (
          <button
            key={answer.id || index}
            onClick={() => handleAnswerClick(index)}
            disabled={isSubmitted}
            style={{
              padding: '16px',
              border: `2px solid ${
                isSubmitted
                  ? index === section.correctAnswerIndex
                    ? '#22c55e'
                    : selectedAnswer === index
                    ? '#ef4444'
                    : '#ccc'
                  : selectedAnswer === index
                  ? '#3b82f6'
                  : '#ccc'
              }`,
              borderRadius: '8px',
              background: isSubmitted
                ? index === section.correctAnswerIndex
                  ? '#dcfce7'
                  : selectedAnswer === index
                  ? '#fee2e2'
                  : 'white'
                : selectedAnswer === index
                ? '#dbeafe'
                : 'white',
              cursor: isSubmitted ? 'default' : 'pointer',
              fontSize: '1rem',
              textAlign: 'left',
              transition: 'all 0.2s'
            }}
          >
            {answer.text}
          </button>
        ))}
      </div>
      {!isSubmitted && selectedAnswer !== null && (
        <Button
          variant="primary"
          onClick={handleSubmit}
          style={{ marginTop: '20px' }}
        >
          {getTranslation('submitAnswer', language)}
        </Button>
      )}
      {isSubmitted && (
        <div
          style={{
            marginTop: '20px',
            padding: '16px',
            borderRadius: '8px',
            border: `2px solid ${isCorrect ? '#22c55e' : '#ef4444'}`,
            background: isCorrect ? '#dcfce7' : '#fee2e2'
          }}
        >
          {isCorrect ? (
            <span>{getTranslation('correct', language)}</span>
          ) : (
            <span>{getTranslation('incorrect', language)} {section.answers[section.correctAnswerIndex]?.text || ''}</span>
          )}
        </div>
      )}
      {isSubmitted && (
        <Button
          variant="outline-secondary"
          onClick={handleReset}
          style={{ marginTop: '12px' }}
        >
          {getTranslation('tryAgain', language)}
        </Button>
      )}
    </div>
  );
};

const ScrollytellingPreviewPage = () => {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem('scrollytelling_preview_sections');
      if (raw) {
        setSections(JSON.parse(raw));
      }
    } catch (e) {
      setSections([]);
    }
  }, []);

  return (
    <Container fluid style={{ background: '#f8f9fa', minHeight: '100vh', padding: '0 0 60px 0' }}>
      <Row className="justify-content-center">
        <Col md={10} lg={8}>
          <h1 className="my-4 text-center">Scrollytelling Preview</h1>
          {sections.length === 0 && (
            <div className="text-center text-muted my-5">No sections to preview.</div>
          )}
          {sections.map((section, idx) => (
            <div key={section.id || idx} style={sectionStyle}>
              {section.visual && section.visual.visualization_url && (
                <iframe
                  src={section.visual.visualization_url}
                  title={section.visual.title || `Visual ${idx + 1}`}
                  style={visualStyle}
                  allowFullScreen
                />
              )}
              <div>
                {section.title && <h3 className="mb-2">{section.title}</h3>}
                {section.type === 'quiz' ? (
                  <QuizPreview section={section} />
                ) : (
                  section.text && <div className="mb-2" style={{ fontSize: '1.1em', color: '#444' }}>{section.text}</div>
                )}
              </div>
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default ScrollytellingPreviewPage;
